export const blockIconsFileRequestQuote = (
	<span className='material-symbols-outlined'>request_quote</span>
);
